exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-start-number-1YVd_{margin-right:20px}.style-start-number-label-1HzMv{font-size:12px;margin-bottom:5px}.style-start-number-input-container-23ElL{display:flex;align-items:center}", ""]);

// Exports
exports.locals = {
	"start-number": "style-start-number-1YVd_",
	"start-number-label": "style-start-number-label-1HzMv",
	"start-number-input-container": "style-start-number-input-container-23ElL"
};